import styled from 'styled-components';
import { ToggleButton, ToggleButtonGroup, spaceMixin, token } from '@zillow/constellation';

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  padding: ${spaceMixin('xs')} ${spaceMixin('sm')} ${spaceMixin('sm')} ${spaceMixin('sm')};
  flex-wrap: wrap;
  margin: 0px auto;
`;

export const StyledToggleButton = styled(ToggleButton)`
  margin: ${spaceMixin('xs')} ${spaceMixin('xs')} ${spaceMixin('sm')} ${spaceMixin('none')};
  border-radius: ${token('radii.pill')} !important;
  display: block;
  margin-left: auto;
  white-space: nowrap;
  background-color: ${token('colors.backgroundWhite')};
  color: ${token('colors.blue400')} !important;

  &:hover {
    border-color: ${token('colors.blue400')} !important;
    background-color: ${token('colors.blue100')} !important;
    color: ${token('colors.blue400')} !important;
  }
`;
